<div class="flex flex-justify-center">
    <div class="progress-bar">
        <span class="progress-bar-fill"
              [ngStyle]="{'width.%': progressPercentage}"></span>
    </div>
</div>
